import * as z from "zod";

export const enableContextual = {
  name: "enableContextual" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
